import React from "react";
import api from "../api";
import axios from "axios";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import InputAdornment from "@material-ui/core/InputAdornment";
import { withStyles } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import ViewIcon from "@material-ui/icons/Visibility";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = theme => ({
  option: {
    fontWeight: 600,
    fontSize: "0.75rem"
  },
  menu: {
    fontSize: "0.75rem"
  },
  root: {
    flexGrow: 1,
    width: "100%"
  },
  appBar: {
    position: "relative"
  },
  title: {
    marginLeft: "2rem",
    flex: 1,
    color: "red"
  },
  paper: {
    padding: "2rem",
    textAlign: "center"
  },
  menu: {
    fontSize: "0.75rem"
  }
});

class SinisterLawyerDiligence extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sinister_lawyer_diligence: { id: "" },
      loading: true,
      snackbar: {},
      providers: {
        loading: false,
        open: false,
        options: [{ business_name: "" }],
        provider: {}
      }
    };
  }

  async componentDidMount() {
    var plate = this.props.plate;
    var work_order_id = this.props.work_order_id;
    await this.getSinisterLawyerDiligence(work_order_id);
    this.setState({ loading: false });
  }

  getSinisterLawyerDiligence = async work_order_id => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(
        api.sinister_lawyer_diligences().work_order_sinister(work_order_id),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        var sinister_lawyer_diligence = {};
        if (res.data[0]) {
          sinister_lawyer_diligence = res.data[0];
          if (res.data[0].sinister) {
            sinister_lawyer_diligence.work_order_id = res.data[0]
              ? res.data[0].sinister.work_order_id
              : {};
          }
        }
        var provider = res.data[0].provider;
        var providers = this.state.providers;
        if (provider) {
          providers.options[0].business_name = provider.business_name;
          providers.provider = provider;
        }
        this.setState({
          sinister_lawyer_diligence: sinister_lawyer_diligence,
          loading: false,
          providers: providers
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleProvidersAsyncChange = (event, values) => {
    var providers = this.state.providers;
    values = values !== null ? values : { business_name: "" };
    providers.provider = values;
    this.setState({ providers: providers });
  };

  handleProvidersAsyncSearch = (event, values) => {
    var provider = values;
    const token = localStorage.getItem("userToken");
    if (provider.length > 2) {
      return axios
        .get(api.providers().index(1, provider, "", "", "", ""), {
          headers: { Authorization: `Bearer ${token}` }
        })
        .then(res => {
          var providers = this.state.providers;
          providers.options = res.data.data;
          this.setState({ providers: providers });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };

  handleChange = e => {
    var sinister_lawyer_diligence = this.state.sinister_lawyer_diligence;
    if (
      [
        "total_ammount_expenses",
        "total_ammount_not_paid",
        "total_ammount_reclaimed",
        "reclaim_paid"
      ].includes(e.target.name)
    ) {
      e.target.value = e.target.value.replace("$", "");
    }
    sinister_lawyer_diligence[e.target.name] = e.target.value;
    this.setState({ sinister_lawyer_diligence });
  };

  handleSubmit = () => {
    var formData = new FormData();
    var url = this.state.sinister_lawyer_diligence.id
      ? api
          .sinister_lawyer_diligences()
          .patch(this.state.sinister_lawyer_diligence.id)
      : api.sinister_lawyer_diligences().post();
    formData.set(
      "sinister_lawyer_diligence[work_order_id]",
      this.props.work_order_id
    );
    formData.set(
      "sinister_lawyer_diligence[provider_id]",
      this.state.providers
        ? this.state.providers.provider.id
          ? this.state.providers.provider.id
          : ""
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[sinister_id]",
      this.state.sinister_lawyer_diligence.sinister_id
        ? this.state.sinister_lawyer_diligence.sinister_id
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[doc_sent_date]",
      this.state.sinister_lawyer_diligence.doc_sent_date
        ? this.state.sinister_lawyer_diligence.doc_sent_date
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[doc_delivered_date]",
      this.state.sinister_lawyer_diligence.doc_delivered_date
        ? this.state.sinister_lawyer_diligence.doc_delivered_date
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[payment_date]",
      this.state.sinister_lawyer_diligence.payment_date
        ? this.state.sinister_lawyer_diligence.payment_date
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[total_ammount_reclaimed]",
      this.state.sinister_lawyer_diligence.total_ammount_reclaimed
        ? this.state.sinister_lawyer_diligence.total_ammount_reclaimed
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[total_ammount_not_paid]",
      this.state.sinister_lawyer_diligence.total_ammount_not_paid
        ? this.state.sinister_lawyer_diligence.total_ammount_not_paid
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[not_paid_reason]",
      this.state.sinister_lawyer_diligence.not_paid_reason
        ? this.state.sinister_lawyer_diligence.not_paid_reason
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[total_ammount_expenses]",
      this.state.sinister_lawyer_diligence.total_ammount_expenses
        ? this.state.sinister_lawyer_diligence.total_ammount_expenses
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[reclaim_paid]",
      this.state.sinister_lawyer_diligence.reclaim_paid
        ? this.state.sinister_lawyer_diligence.reclaim_paid
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[expenses_date]",
      this.state.sinister_lawyer_diligence.expenses_date
        ? this.state.sinister_lawyer_diligence.expenses_date
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[expenses_reason]",
      this.state.sinister_lawyer_diligence.expenses_reason
        ? this.state.sinister_lawyer_diligence.expenses_reason
        : ""
    );
    formData.set(
      "sinister_lawyer_diligence[company_name_reclaimed]",
      this.state.sinister_lawyer_diligence.company_name_reclaimed
        ? this.state.sinister_lawyer_diligence.company_name_reclaimed
        : ""
    );

    if (this.state.sinister_lawyer_diligence.id) {
      formData.set(
        "sinister_lawyer_diligence[id]",
        this.state.sinister_lawyer_diligence.id
      );
      formData.set("_method", "PATCH");
    }

    let self = this;
    const token = localStorage.getItem("userToken");
    axios
      .post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        var snackbar = {
          openSuccess: true,
          success_message: "Datos cargados con éxito",
          severity: "success"
        };
        self.setState({ snackbar: snackbar });
        self.getSinisterLawyerDiligence(this.props.work_order_id);
      })
      .catch(function(error) {
        var error_message = "";
        var errors = error.response.data;
        if (errors.errors) {
          if (errors.errors.status_code !== 404) {
            var keys = Object.keys(errors.errors);
            for (var i = 0; i < keys.length; i++) {
              var key = keys[i];
              var key_errors = errors.errors[key];
              key_errors.map((val, idx) => {
                error_message = error_message.concat(val).concat(" ");
              });
            }
          } else {
            error_message = "Ha ocurrido un error. Contacte a su administrador";
          }
        } else {
          error_message = "Ha ocurrido un error. Contacte a su administrador";
        }
        var snackbar = {
          openSuccess: true,
          success_message: error_message,
          severity: "warning"
        };

        self.setState({ snackbar: snackbar });
      });
  };

  handleCloseSuccess = () => {
    var snackbar = this.state.snackbar;
    snackbar = { openSuccess: false, success_message: "", severity: "" };
    this.setState({ snackbar });
  };

  getSinister = async () => {
    const token = localStorage.getItem("userToken");
    return await axios
      .get(
        api
          .sinisters()
          .work_order_sinister(
            this.state.sinister_lawyer_diligence.work_order_id
          ),
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(res => {
        var { id } = res.data[0];
        var sinister_lawyer_diligence = this.state.sinister_lawyer_diligence;
        sinister_lawyer_diligence.sinister_id = id;
        this.setState({ sinister_lawyer_diligence });
      })
      .catch(err => {
        console.log(err);
      });
  };

  render() {
    const classes = this.props.classes;
    return (
      <div className="mt-2">
        <Snackbar
          open={this.state.snackbar.openSuccess}
          autoHideDuration={10000}
          onClose={this.handleCloseSuccess}
        >
          <Alert
            onClose={this.handleCloseSuccess}
            severity={this.state.snackbar.severity}
          >
            {this.state.snackbar.success_message}
          </Alert>
        </Snackbar>

        {!this.state.loading ? (
          <React.Fragment>
            <div className="row mt-2">
              <TextField
                id="work_order_id"
                name="work_order_id"
                value={
                  this.state.sinister_lawyer_diligence.work_order_id
                    ? this.state.sinister_lawyer_diligence.work_order_id
                    : ""
                }
                onBlur={this.getSinister}
                onChange={this.handleChange}
                type="text"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        #OT Siniestro{" "}
                        {this.state.sinister_lawyer_diligence.sinister_id >
                        0 ? (
                          <ViewIcon
                            fontSize="small"
                            className="ml-1"
                            onClick={() =>
                              window.open(
                                "/work-order/" +
                                  this.state.sinister_lawyer_diligence
                                    .work_order_id
                              )
                            }
                          />
                        ) : (
                          ""
                        )}
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                id="sinister_id"
                name="sinister_id"
                value={
                  this.state.sinister_lawyer_diligence.sinister_id
                    ? this.state.sinister_lawyer_diligence.sinister_id
                    : ""
                }
                disabled
                type="text"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption"># Siniestro</Typography>
                    </InputAdornment>
                  )
                }}
              />

              {this.state.sinister_lawyer_diligence.provider_id > 0 ? (
                <TextField
                  id="provider_business_name"
                  value={this.state.providers.provider.business_name}
                  //onChange={this.handleChange}
                  type="text"
                  disabled
                  name="provider_business_name"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { width: 150, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Proveedor</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              ) : (
                <Autocomplete
                  id="provider"
                  style={{ width: 200 }}
                  getOptionLabel={option => option.business_name}
                  getOptionSelected={(option, value) =>
                    option.business_name === value
                  }
                  options={this.state.providers.options}
                  loading={this.state.providers.loading}
                  onInputChange={this.handleProvidersAsyncSearch}
                  onChange={this.handleProvidersAsyncChange.bind(this)}
                  value={this.state.providers.options.find(
                    v =>
                      v.business_name ===
                      this.state.providers.provider.business_name
                  )}
                  autoComplete
                  noOptionsText={
                    <Typography variant="caption">Sin resultados</Typography>
                  }
                  name="provider"
                  includeInputInList
                  className="mt-1 mr-2"
                  classes={{
                    option: classes.option
                  }}
                  renderInput={params => (
                    <TextField
                      {...params}
                      placeholder="Ingrese un abogado"
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {this.state.providers.loading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                        startAdornment: (
                          <Typography variant="caption">Abogado</Typography>
                        )
                      }}
                      InputLabelProps={{
                        ...params.InputLabelProps,
                        shrink: true
                      }}
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: "0.75rem", width: 70 }
                      }}
                    />
                  )}
                />
              )}
              <TextField
                id="company_name_reclaimed"
                name="company_name_reclaimed"
                value={
                  this.state.sinister_lawyer_diligence.company_name_reclaimed
                    ? this.state.sinister_lawyer_diligence
                        .company_name_reclaimed
                    : ""
                }
                onChange={this.handleChange}
                type="text"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">
                        Aseguradora del tercero:
                      </Typography>
                    </InputAdornment>
                  )
                }}
              />

              <TextField
                id="doc_sent_date"
                name="doc_sent_date"
                value={
                  this.state.sinister_lawyer_diligence.doc_sent_date
                    ? this.state.sinister_lawyer_diligence.doc_sent_date
                    : ""
                }
                onChange={this.handleChange}
                type="date"
                margin="normal"
                className="m-0 p-0 mr-2"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption">Fecha envio doc</Typography>
                    </InputAdornment>
                  )
                }}
              />
              {/*<TextField
							id="doc_delivered_date"
							name="doc_delivered_date"
							value={(this.state.sinister_lawyer_diligence.doc_delivered_date) ? this.state.sinister_lawyer_diligence.doc_delivered_date : ''}
							onChange={this.handleChange}
							type="date"
							margin="normal"
							className="m-0 p-0 mr-2"
							InputLabelProps={{
								shrink: true
							}}
							inputProps={{style:{minWidth: 150, fontSize: '0.75rem'}}}
							InputProps={{
							    startAdornment: <InputAdornment position="start" ><Typography variant="caption">Fecha recepción doc</Typography></InputAdornment>,
							}}

						/>*/}

              <div className="col-12">
                <NumberFormat
                  id="total_ammount_reclaimed"
                  name="total_ammount_reclaimed"
                  value={
                    this.state.sinister_lawyer_diligence.total_ammount_reclaimed
                      ? this.state.sinister_lawyer_diligence
                          .total_ammount_reclaimed
                      : 0
                  }
                  className="mr-2"
                  onChange={this.handleChange}
                  InputProps={{
                    style: { fontSize: "0.75rem", width: 250 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Monto reclamado
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  decimalSeparator="."
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  customInput={TextField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
              </div>
              <div className="col-12">
                <NumberFormat
                  id="total_ammount_expenses"
                  name="total_ammount_expenses"
                  value={
                    this.state.sinister_lawyer_diligence.total_ammount_expenses
                      ? this.state.sinister_lawyer_diligence
                          .total_ammount_expenses
                      : 0
                  }
                  onChange={this.handleChange}
                  className="mr-2"
                  InputProps={{
                    style: { fontSize: "0.75rem", width: 250 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Gastos asociados
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  decimalSeparator="."
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  customInput={TextField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  id="expenses_date"
                  name="expenses_date"
                  value={
                    this.state.sinister_lawyer_diligence.expenses_date
                      ? this.state.sinister_lawyer_diligence.expenses_date
                      : ""
                  }
                  onChange={this.handleChange}
                  type="date"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Fecha gastos</Typography>
                      </InputAdornment>
                    )
                  }}
                />
                <TextField
                  id="expenses_reason"
                  name="expenses_reason"
                  value={
                    this.state.sinister_lawyer_diligence.expenses_reason
                      ? this.state.sinister_lawyer_diligence.expenses_reason
                      : ""
                  }
                  onChange={this.handleChange}
                  type="text"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 350, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">Motivo gastos</Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
              <div className="col-12">
                <NumberFormat
                  id="reclaim_paid"
                  name="reclaim_paid"
                  value={
                    this.state.sinister_lawyer_diligence.reclaim_paid
                      ? this.state.sinister_lawyer_diligence.reclaim_paid
                      : 0
                  }
                  onChange={this.handleChange}
                  className="mr-2"
                  InputProps={{
                    style: { fontSize: "0.75rem", width: 250 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Total recuperado
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  decimalSeparator="."
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  customInput={TextField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  id="payment_date"
                  name="payment_date"
                  value={
                    this.state.sinister_lawyer_diligence.payment_date
                      ? this.state.sinister_lawyer_diligence.payment_date
                      : ""
                  }
                  onChange={this.handleChange}
                  type="date"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { minWidth: 150, fontSize: "0.75rem" } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Fecha pago seguro
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
              <div className="col-12">
                <NumberFormat
                  id="total_ammount_not_paid"
                  name="total_ammount_not_paid"
                  value={
                    this.state.sinister_lawyer_diligence.total_ammount_not_paid
                      ? this.state.sinister_lawyer_diligence
                          .total_ammount_not_paid
                      : 0
                  }
                  className="mr-2"
                  onChange={this.handleChange}
                  InputProps={{
                    style: { fontSize: "0.75rem", width: 250 },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Monto no recuperado
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                  decimalSeparator="."
                  prefix={"$"}
                  decimalScale={2}
                  fixedDecimalScale={true}
                  customInput={TextField}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  id="not_paid_reason"
                  name="not_paid_reason"
                  value={
                    this.state.sinister_lawyer_diligence.not_paid_reason
                      ? this.state.sinister_lawyer_diligence.not_paid_reason
                      : ""
                  }
                  onChange={this.handleChange}
                  type="text"
                  margin="normal"
                  className="m-0 p-0 mr-2"
                  InputLabelProps={{
                    shrink: true
                  }}
                  inputProps={{ style: { fontSize: "0.75rem", minWidth: 350 } }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Typography variant="caption">
                          Motivo de no recuperado
                        </Typography>
                      </InputAdornment>
                    )
                  }}
                />
              </div>
            </div>
            <div className="row mt-1">
              <Button
                disabled={
                  this.state.sinister_lawyer_diligence.sinister_id > 0
                    ? false
                    : true
                }
                className="mr-2"
                variant="contained"
                color="primary"
                size="small"
                style={{ fontSize: "0.75rem" }}
                onClick={e => {
                  this.handleSubmit(e);
                }}
              >
                Guardar
              </Button>
            </div>
          </React.Fragment>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default withStyles(useStyles)(SinisterLawyerDiligence);
